import { useQuery } from "@tanstack/react-query";

import { SystemSettingKey, systemSettingsApi } from "@/api";
import { QueryKey } from "@/query/Query";

/**
 * Fetches the configured translation tool URL from system settings.
 * Returns null when the setting is not configured or holds a non-string value.
 */
export function useTranslationToolUrl(): string | null {
  const { data } = useQuery({
    queryKey: [QueryKey.SystemSetting, SystemSettingKey.TranslationToolUrl],
    queryFn: () => systemSettingsApi.getSystemSetting({ key: SystemSettingKey.TranslationToolUrl }),
  });

  return typeof data?.value === "string" ? data.value : null;
}
